module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
rethrow = rethrow || function rethrow(err, str, flnm, lineno, esc){
  var lines = str.split('\n');
  var start = Math.max(lineno - 3, 0);
  var end = Math.min(lines.length, lineno + 3);
  var filename = esc(flnm); // eslint-disable-line
  // Error context
  var context = lines.slice(start, end).map(function (line, i){
    var curr = i + start + 1;
    return (curr == lineno ? ' >> ' : '    ')
      + curr
      + '| '
      + line;
  }).join('\n');

  // Alter exception message
  err.path = filename;
  err.message = (filename || 'ejs') + ':'
    + lineno + '\n'
    + context + '\n\n'
    + err.message;

  throw err;
};
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
var __line = 1
  , __lines = "<div>\n<%\nif(environment.style == 'mobile'){\nvar img  = (model.imgMobile  ? model.imgMobile  : model.img1);\nvar _img = (model._imgMobile ? model._imgMobile : model._img1);\nvar title = (model.titleMobile != \"\" ? model.titleMobile : model.title);\nvar text  = (model.textMobile != \"\"  ? model.textMobile  : model.text);\n%>\n<%- include('../../../mobile/1it-1tbb-base/1it-1tbb-base', { model: { title: title, text: text, buttonText: model.buttonText, buttonColor: model.buttonColor, buttonAction: model.buttonAction, img: img, _img: _img } }); %>\n<%\n} else {\n%>\n<div class=\"texts\">\n<h2><%- model.title %></h2>\n<%- model.text %>\n</div>\n<div class=\"images\">\n<%          var i1 = (helpers.detectRenderedImage(model.img1, model._img1) || {}).rendered || {};\nvar i2 = (helpers.detectRenderedImage(model.img2, model._img2) || {}).rendered || {};\nvar i3 = (helpers.detectRenderedImage(model.img3, model._img3) || {}).rendered || {};\nif (environment.device && environment.device.type==\"bot\") {\n%>              <img src=\"<%= i1.url %>\" alt=\"<%= i1.alt %>\" title=\"<%= i1.title %>\">\n<img src=\"<%= i2.url %>\" alt=\"<%= i2.alt %>\" title=\"<%= i2.title %>\">\n<img src=\"<%= i3.url %>\" alt=\"<%= i3.alt %>\" title=\"<%= i3.title %>\">\n<%          } else { %>\n<div class=\"circle c1\" style=\"background-image:url(<%= i1.url %>)\"><div><%= model.imgText1 %></div></div>\n<div class=\"circle c2\" style=\"background-image:url(<%= i2.url %>)\"><div><%= model.imgText2 %></div></div>\n<div class=\"circle c3\" style=\"background-image:url(<%= i3.url %>)\"><div><%= model.imgText3 %></div></div>\n<%          } %>\n</div>\n<% } %>\n</div>"
  , __filename = "components/templates/circles/1tl-3irt/1tl-3irt.ejs";
try {
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; __append("<div>\n")
    ; __line = 2
    ; 
if(environment.style == 'mobile'){
var img  = (model.imgMobile  ? model.imgMobile  : model.img1);
var _img = (model._imgMobile ? model._imgMobile : model._img1);
var title = (model.titleMobile != "" ? model.titleMobile : model.title);
var text  = (model.textMobile != ""  ? model.textMobile  : model.text);

    ; __line = 8
    ; __append("\n")
    ; __line = 9
    ; __append( include('../../../mobile/1it-1tbb-base/1it-1tbb-base', { model: { title: title, text: text, buttonText: model.buttonText, buttonColor: model.buttonColor, buttonAction: model.buttonAction, img: img, _img: _img } }) )
    ; __append("\n")
    ; __line = 10
    ; 
} else {

    ; __line = 12
    ; __append("\n<div class=\"texts\">\n<h2>")
    ; __line = 14
    ; __append( model.title )
    ; __append("</h2>\n")
    ; __line = 15
    ; __append( model.text )
    ; __append("\n</div>\n<div class=\"images\">\n")
    ; __line = 18
    ;           var i1 = (helpers.detectRenderedImage(model.img1, model._img1) || {}).rendered || {};
var i2 = (helpers.detectRenderedImage(model.img2, model._img2) || {}).rendered || {};
var i3 = (helpers.detectRenderedImage(model.img3, model._img3) || {}).rendered || {};
if (environment.device && environment.device.type=="bot") {

    ; __line = 22
    ; __append("              <img src=\"")
    ; __append(escapeFn( i1.url ))
    ; __append("\" alt=\"")
    ; __append(escapeFn( i1.alt ))
    ; __append("\" title=\"")
    ; __append(escapeFn( i1.title ))
    ; __append("\">\n<img src=\"")
    ; __line = 23
    ; __append(escapeFn( i2.url ))
    ; __append("\" alt=\"")
    ; __append(escapeFn( i2.alt ))
    ; __append("\" title=\"")
    ; __append(escapeFn( i2.title ))
    ; __append("\">\n<img src=\"")
    ; __line = 24
    ; __append(escapeFn( i3.url ))
    ; __append("\" alt=\"")
    ; __append(escapeFn( i3.alt ))
    ; __append("\" title=\"")
    ; __append(escapeFn( i3.title ))
    ; __append("\">\n")
    ; __line = 25
    ;           } else { 
    ; __append("\n<div class=\"circle c1\" style=\"background-image:url(")
    ; __line = 26
    ; __append(escapeFn( i1.url ))
    ; __append(")\"><div>")
    ; __append(escapeFn( model.imgText1 ))
    ; __append("</div></div>\n<div class=\"circle c2\" style=\"background-image:url(")
    ; __line = 27
    ; __append(escapeFn( i2.url ))
    ; __append(")\"><div>")
    ; __append(escapeFn( model.imgText2 ))
    ; __append("</div></div>\n<div class=\"circle c3\" style=\"background-image:url(")
    ; __line = 28
    ; __append(escapeFn( i3.url ))
    ; __append(")\"><div>")
    ; __append(escapeFn( model.imgText3 ))
    ; __append("</div></div>\n")
    ; __line = 29
    ;           } 
    ; __append("\n</div>\n")
    ; __line = 31
    ;  } 
    ; __append("\n</div>")
    ; __line = 32
  }
  return __output;
} catch (e) {
  rethrow(e, __lines, __filename, __line, escapeFn);
}

//# sourceURL=components/templates/circles/1tl-3irt/1tl-3irt.ejs

}